import InscriptionPage from '../InscriptionPage/InscriptionPage';

function WeeklyTalkPage() {
  return <InscriptionPage purpose="weekly-talk" />;
}

export default WeeklyTalkPage;
